import Typography from '@material-ui/core/Typography';
import { cloneElement } from 'react';

import LoadingBar from '~/components/LoadingBar';

import styles from './styles';

const ConnectorSyncAlert = ({ accountConnector, classes, name, icon }) => {
  const remoteMeta = accountConnector?.remoteMeta;

  const syncProgress = remoteMeta?.syncProgress;

  return (
    <li className={classes.connectorSyncAlert}>
      {cloneElement(icon, { className: classes.logo })}
      <div className={classes.syncAlertDetail}>
        <Typography className={classes.syncMessage}>
          Your initial {name} sync with Clearbit X is in progress
        </Typography>
        <Typography className={classes.syncSubtext}>
          Until the sync completes your full {name} dataset will not be
          available.
        </Typography>
      </div>
      <div className={classes.loadingContainer}>
        <div className={classes.linearLoadingContainer}>
          <LoadingBar
            className={classes.loadingBar}
            currentPercentage={syncProgress}
            speed="fast"
          />
          <Typography className={classes.syncState}>
            Sync {syncProgress + '%'} complete
          </Typography>
        </div>
      </div>
    </li>
  );
};

ConnectorSyncAlert.propTypes = {
  classes: PropTypes.object,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  accountConnector: PropTypes.shape({
    remoteMeta: PropTypes.object,
  }),
};

export default withStyles(styles)(ConnectorSyncAlert);
